import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class EmbargoCancellationService {

  constructor(
    private http: HttpClient
  ) {}

  getCancellationList(page, requestEntity): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });

    return this.http.get<any>(`${environment.BACKEND}oficio/request/list?requestEntity=${requestEntity}`, {
      params: httpParams
    });
  }

  getCSVRequestDownload(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });

    return this.http.get<any>(`${environment.BACKEND}oficio/request/download`, {
      params: httpParams
    });
  }

  

  confirmMassive(formData): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}oficio/request/confirmMassive`, formData);
  }

  createMassive(formData): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}oficio/request/createMassive`, formData);
  }

  cancellationConfirm(idE, requestEntit): Observable<any> {
    let requestEntity = requestEntit.toString()
    let id = idE.toString() 
    return this.http.post<any>(`${environment.BACKEND}oficio/request/confirm`, { id, requestEntity });
  }

  cancellationDeny(id, requestEntit): Observable<any> {
    let requestEntity = requestEntit.toString()
    return this.http.post<any>(`${environment.BACKEND}oficio/request/deny`, { id, requestEntity });
  }

}
